(function () {
    'use strict';

    angular.module('app.live-editor', [])
        .directive('liveEditor', liveEditor);

    /* @ngInject */
    function liveEditor(SETTINGS, $rootScope, ContentFactory) {
        return {
            restrict: 'E',
            template: '',
            scope: {
                id: '@',
				contentKey: '@',
				readonly: '=',
				mode: '@'
            },
            link: link
        };
		
		function isInitialized(elm) {
			return ($(elm).data('froala.editor'));
		}

        function link(scope, elm, attrs) {

            var mode = '',
				content,
				readonly = !$rootScope.allowEditingContent
			;
			
			if (angular.isDefined(scope.mode)) {
				mode = scope.mode;
			}
			if (angular.isDefined(scope.readonly)) {
				readonly = scope.readonly;
			}

			ContentFactory.load(scope.contentKey).then(function(response) {
				if (response) {
					content = response.value;
	                if (!isInitialized(elm)) {
						elm.empty();
						elm.append(content);
						if (!readonly) {
							render();
						}
	                } else {
	                	$(elm).froalaEditor('html.set', content);
	                }
				}
	        });

            function render() {
				var saveCmd = 'save_' + scope.id;
				$.FroalaEditor.DefineIcon(saveCmd, {NAME: 'save'});
			    $.FroalaEditor.RegisterCommand(saveCmd, {
			      title: 'Save',
			      focus: true,
			      undo: false,
			      refreshAfterCallback: false,
			      callback: function () {
					  // do some save
					  content = this.html.get();
					  ContentFactory.save(scope.contentKey, content);
					  $(elm).froalaEditor('destroy');
	                  render();
			      }
			    });
			
				var closeCmd = 'close_' + scope.id;
				$.FroalaEditor.DefineIcon(closeCmd, {NAME: 'close'});
			    $.FroalaEditor.RegisterCommand(closeCmd, {
			      title: 'Cancel',
			      focus: true,
			      undo: false,
			      refreshAfterCallback: false,
			      callback: function () {
	              	  this.html.set(content);
					  $(elm).froalaEditor('destroy');
	                  render();
			      }
			    });

				var toolbarButtons = [ closeCmd, saveCmd ];
				if (mode === 'compact') {
					toolbarButtons = toolbarButtons.concat([ 'bold', 'italic', 'underline', 'fontFamily', 'fontSize', 'color', 'clearFormatting' ]);
				} else {
					toolbarButtons = toolbarButtons.concat([ 'fullscreen', 'bold', 'italic', 'underline', 'fontFamily', 'fontSize', 'color', 'paragraphStyle', 'paragraphFormat', 'align', 'formatOL', 'formatUL', 'outdent', 'indent', 'quote', 'insertHR', 'insertLink', 'undo', 'redo', 'clearFormatting', ]);
				}
				
				var colors = SETTINGS.PALETTE;
				colors.push('REMOVE');
				
	            var config = {
			      	initOnClick: true,
					toolbarButtons: toolbarButtons,
					colorsBackground: colors,
					colorsText: colors,
			    };
                $(elm).froalaEditor(config);
            }
        }
    }
})();